import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagina-areas',
  templateUrl: './pagina-areas.component.html',
  styleUrls: ['./pagina-areas.component.scss']
})
export class PaginaAreasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
